const contentArticleType = [
    { key: "MARKET_INSIGHT", value: "MARKET_INSIGHT" },
    { key: "INDUSTRY_INSIGHT", value: "INDUSTRY_INSIGHT" },
    { key: "PRODUCT_INSIGHT", value: "PRODUCT_INSIGHT" },
    { key: "SERVICE_INSIGHT", value: "SERVICE_INSIGHT" },
    { key: "COMPANY_INSIGHT", value: "COMPANY_INSIGHT" },
    { key: "TRAINING_SESSION", value: "TRAINING_SESSION" },
];

export { contentArticleType };